import type { CreateSessionBody } from './types'

/**
 * The GET /sessions/:id envelope (build-contract §3.3) does not echo back
 * `roster_user_ids` or the raw `vibe_text` — only the parsed `vibe_constraints`,
 * coverage_k, and togetherness_mode. The results screen needs the original
 * inputs to (a) re-roll and (b) reveal wildcards via an opt-in re-POST.
 *
 * Until the contract adds those fields to the session response, we stash the
 * submitted body client-side keyed by session id. This is a pure convenience
 * cache — the backend remains the source of truth; a missing snapshot just means
 * "re-roll/reveal sends the user back to the builder" instead of breaking.
 *
 * See the "notes" handoff: requesting `roster_user_ids` (+ optional `vibe_text`,
 * `wildcard_opt_in`) on the session response would remove this shim.
 */
const KEY_PREFIX = 'fireside.session.'

export function saveSessionSnapshot(sessionId: string, body: CreateSessionBody): void {
  try {
    sessionStorage.setItem(KEY_PREFIX + sessionId, JSON.stringify(body))
  } catch {
    // Storage unavailable (private mode / quota) — degrade silently.
  }
}

export function loadSessionSnapshot(sessionId: string): CreateSessionBody | null {
  try {
    const raw = sessionStorage.getItem(KEY_PREFIX + sessionId)
    return raw ? (JSON.parse(raw) as CreateSessionBody) : null
  } catch {
    return null
  }
}
